<template>
    <div class="subPage_container">
        <MarketView :tableComponent="PriceTable" webSocketUrl="wss://ws2.goya-alert.com/price"
            webSocketMessageFormat="fetch_{tab}_up" />
    </div>
</template>

<script>
import MarketView from './sub/MarketView.vue';
import PriceTable from './sub/PriceTable.vue';

export default {
    components: {
        MarketView
    },
    data() {
        return {
            PriceTable
        };
    }
};
</script>